(function() {
  // Load Shopify Customer Privacy API
  let shopifyCustomerPrivacyLoaded = false;
  let pendingConsentSync = null;
  
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ], function(error) {
      if (error) {
        console.error('Error loading Shopify Customer Privacy API:', error);
      } else {
        shopifyCustomerPrivacyLoaded = true;
        
        // Sync any pending consent that arrived before API loaded
        if (pendingConsentSync) {
          syncToShopify(pendingConsentSync);
          pendingConsentSync = null;
        }
      }
    });
  }

  // Helper function to sync consent to Shopify
  function syncToShopify(consentState) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: consentState.statistics,
        marketing: consentState.marketing,
        preferences: consentState.preferences,
      });
    }
  }

  // Helper function to handle consent updates
  function handleConsentUpdate() {
    if (!window.Cookiebot || !window.Cookiebot.consent) {
      console.warn('Cookiebot not ready yet');
      return; // Cookiebot not ready yet
    }
    // Check the updated Cookiebot consent state
    const consentState = {
      necessary: Cookiebot.consent.necessary,
      preferences: Cookiebot.consent.preferences,
      statistics: Cookiebot.consent.statistics,
      marketing: Cookiebot.consent.marketing,
    };

    // Publish to custom pixel (for GTM)
    Shopify.analytics.publish('cookiebot_update', {
      consentState
    });

    // Sync consent to Shopify Customer Privacy API (or queue if not ready)
    if (shopifyCustomerPrivacyLoaded) {
      syncToShopify(consentState);
    } else {
      pendingConsentSync = consentState;
    }
  }

  // Listen to Cookiebot consent ready event
  // This fires on initial load AND whenever user changes consent preferences
  window.addEventListener('CookiebotOnConsentReady', handleConsentUpdate);    

  /*
  event dispatch from product card
  */

  document.addEventListener('product_clicked', function (event) {
    Shopify.analytics.publish('product_clicked', event.detail);
  });

  /*
  event swatch color dispatch from PDP 
  */

  document.addEventListener('product_viewed_custom', function (event) {
    Shopify.analytics.publish('product_viewed_custom', event.detail);
  });

  /* 
    * List View Events
    */
  let visibleProductsQueue = [];
  let sentProductIds = new Set();  // Set to track already sent product IDs
  let productElements = null;

  // Function to process and send the visible products
  function checkAndSendVisibleProducts() {
    if (!productElements) {
      productElements = document.querySelectorAll('[data-product-card]');    
    }
    
    productElements.forEach((el, index) => {
      const variantId = el.querySelector('[data-reference-slider]')?.getAttribute('data-variant');

      if (isElementInViewport(el) && !sentProductIds.has(variantId)) {
        visibleProductsQueue.push({
          variantId,
          index: index + 1
        });
        sentProductIds.add(variantId);  // Add to sent products to avoid duplicates
      }
    });
  }

  // Function to send the products queue to GA4 every second
  // This executes as user scrolls through the product list
  function sendProductQueueToGA4() {
    if (visibleProductsQueue.length > 0) {
      Shopify.analytics.publish('product_list_viewed', {
        items: visibleProductsQueue
      });
      visibleProductsQueue = [];  // Clear the queue after sending
    }
  }

  // Function to execute on page load, scroll, and resize
  function handleVisibilityCheck() {
    checkAndSendVisibleProducts();
  }

  // Initialize on load
  window.addEventListener('DOMContentLoaded', handleVisibilityCheck);

  // Debounced scroll and resize events
  window.addEventListener('scroll', debounce(handleVisibilityCheck, 200));
  window.addEventListener('resize', debounce(handleVisibilityCheck, 200));

  // Send the product queue every second
  setInterval(sendProductQueueToGA4, 1000);


  // Helper function to check if an element is in the viewport
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

    
  // Debounce function to limit how often a function is called
  function debounce(func, delay) {
    let debounceTimer;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  }

  // This executes when user changes product sibling via swatches in PDP (gtmEventsListViewed)
  document.addEventListener('product_list_viewed', function (event) {
    // Adaptamos el formato para que coincida con el esperado por Shopify.analytics
    Shopify.analytics.publish('product_list_viewed', {
      items: [event.detail]  // Envolvemos el detalle en un array como se hace en sendProductQueueToGA4
    });
  });
})();
  
  